import { Reducer } from 'redux';
import { HarvestAction, HarvestActions } from '../actions/harvestActions';
import { HarvestState } from '../actions/harvest/types/state';

export const initialState: HarvestState = {};

const harvestReducer: Reducer<HarvestState, HarvestActions> = (state = initialState, action: HarvestActions) => {
  switch (action.type) {
    case HarvestAction.ReceiveHarvestMetadata: {
      const harvestResults = action.metadata.reduce((result, season) => {
        const {
          area,
          mass,
          seasonTag,
          yieldAverage,
          dryYieldAverage,
          totalYield,
          standardisedAverageYield
        } = season;

        return {
          ...result,
          [seasonTag]: {
            area: area.harvest,
            avgMoisture: mass.avgMoisture,
            avgYield: yieldAverage,
            totalYield,
            ...(dryYieldAverage ? {
              avgDryYield: dryYieldAverage, 
            }: { }),
            standardisedAverageYield,
            dryMass: mass.dry,
            wetMass: mass.wet
          },
        };
      }, {});

      return {
        ...state,
        ...harvestResults,
      };
    }

    default:
      return state;
  }
}

export default harvestReducer;
